/* Vanilla JS Custom Element for Product Image Carousel */

class ProductCarousel extends HTMLElement {
    constructor() {
        super();
        this.track = this.querySelector('.product-carousel__scroll-track');
        this.dots = this.querySelectorAll('.carousel-dot');
        this.items = this.querySelectorAll('.product-carousel__item');

        // Bindiamo 'this' per i listener
        this.onScroll = this.onScroll.bind(this);
        this.onDotClick = this.onDotClick.bind(this);

        this.init();
    }

    init() {
        if (!this.track || this.dots.length === 0) return;

        // Listener per i pallini
        this.dots.forEach(dot => {
            dot.addEventListener('click', this.onDotClick);
        });

        // Listener per aggiornare i pallini quando scroliamo nativamente con il dito
        this.track.addEventListener('scroll', this.debounce(this.onScroll, 50));
    }

    onDotClick(event) {
        const targetIdx = event.currentTarget.dataset.index;
        const itemTarget = this.items[targetIdx];

        if (itemTarget) {
            // Scorrimento nativo HTML5 fluido
            const offset = itemTarget.offsetLeft - this.track.offsetLeft;
            this.track.scrollTo({ left: offset, behavior: 'smooth' });
        }
    }

    onScroll() {
        // Calcoliamo quale immagine è attualmente visibile
        const scrollLeft = this.track.scrollLeft;
        // Troviamo l'indice più vicino al centro visivo
        let closestIndex = Math.round(scrollLeft / this.track.clientWidth);

        // Limitiamo l'indice ai bordi
        closestIndex = Math.max(0, Math.min(closestIndex, this.items.length - 1));

        this.updateDots(closestIndex);
    }

    updateDots(activeIndex) {
        this.dots.forEach((dot, index) => {
            if (index === activeIndex) {
                dot.classList.add('is-active');
                dot.setAttribute('aria-current', 'true');
            } else {
                dot.classList.remove('is-active');
                dot.setAttribute('aria-current', 'false');
            }
        });
    }

    // Semplice debounce function per ottimizzare lo scroll listener
    debounce(func, wait) {
        let timeout;
        return function () {
            const context = this;
            const args = arguments;
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(context, args), wait);
        };
    }
}

// Registriamo il Web Component se non esiste già
if (!customElements.get('product-carousel')) {
    customElements.define('product-carousel', ProductCarousel);
}
